import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { StackLayout } from '@progress/kendo-react-layout'
import { Notification, NotificationGroup } from '@progress/kendo-react-notification'
import { Slide } from '@progress/kendo-react-animation'
import { useTimelimitedFlag } from '../hooks'
import { useEffect, useState } from 'react'
import { Button } from '@progress/kendo-react-buttons'

export interface ErrorMessage {
  id: string
  content: string
}

export interface ErrorMessagesProps {
  type: 'dialog' | 'notification'
  title?: string
  messages: ErrorMessage[]
  style?: React.CSSProperties
}

export function ErrorMessages(props: ErrorMessagesProps) {
  if (props.type === 'dialog') {
    // ダイアログで表示
    const [shown, setShow] = useState(false)

    useEffect(() => {
      setShow(props.messages.length > 0)
    }, [props.messages])

    return (
      <>
        {shown &&
          <Dialog style={props.style} title={props.title ?? 'エラーが発生しました'} closeIcon onClose={() => setShow(false)}>
            <StackLayout orientation='vertical' style={{ minWidth: 300 }}>
              {props.messages.map(message => {
                return (<div key={message.id}><strong>{message.id} {message.content}</strong></div>)
              })}
            </StackLayout>
            <DialogActionsBar>
              <StackLayout orientation='horizontal' align={{ horizontal: 'end' }}>
                <Button className='pcy-button-long' onClick={() => setShow(false)}>閉じる</Button>
              </StackLayout>
            </DialogActionsBar>
          </Dialog >
        }
      </>
    )
  } else if (props.type === 'notification') {
    // 通知で表示
    const [shown, show, hide] = useTimelimitedFlag(5000)

    useEffect(() => {
      show()
    }, [props.messages])

    return (
      <NotificationGroup style={{ bottom: 0, right: 0, alignItems: 'flex-end', ...props.style }}>
        {props.messages.map(message => {
          const firstLetter = message.id.charAt(0)
          let style: 'none' | 'info' | 'warning' | 'error'
          switch (firstLetter) {
            case 'I': style = 'info'; break
            case 'W': style = 'warning'; break
            case 'E': style = 'error'; break
            default: style = 'none'; break
          }
          return (
            <Slide key={message.id} direction='left'>
              {shown &&
                <Notification type={{ icon: true, style }} closable onClose={() => hide()}>
                  <span>{message.id} {message.content}</span>
                </Notification>
              }
            </Slide>
          )
        })}
      </NotificationGroup>
    )
  }
  return <></>
}
